import styled from "styled-components";

export const CheckTransportationModalLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;

  p {
    text-align: center;
    font-size: 1.4rem;
    font-weight: 500;
  }
`;
